import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { Layout, Menu, Button, theme, App, Space } from 'antd';
import { useEffect, useState } from "react";
import { getSidebarMenu } from "../helpers/get-sidebar-menu";
import DronePartsPage from "../pages/drone-parts-page/drone-parts-page";
import HomePage from "../pages/home-page/home-page";
import SettingsPage from "../pages/settings-page/settings-page";
import SuppliersPage from "../pages/suppliers-page/suppliers-page";
import StorePage from "../pages/store-page/store-page";
import DronesPage from "../pages/drones-page/drones-page";
import OrdersPage from "../pages/orders/orders-page";
import Batteries from "../pages/batteries/batteries";
import PathHeader from "../components/path-header";
import DroneComplect from '../pages/drone-complect/drone-complect';
import HomePageV2 from "../v2/pages/HomePage";
import SuppliersPageV2 from "../v2/pages/SuppliersPage";
import StockPageV2 from "../v2/pages/StockPage";
import ProductsPageV2 from "../v2/pages/ProductsPage";
import DraftsPageV2 from "../v2/pages/DraftsPage";
import SettingsPageV2 from "../v2/pages/SettingsPage";
import OrdersPageV2 from "../v2/pages/OrdersPage";
import LinksPage from "../v2/pages/LinksPage";
import { observer } from "mobx-react-lite";
import MainToolbar from "../containers/mainToolbar";

const {
  Header,
  Sider,
  Content
} = Layout;

export function Application() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { notification} = App.useApp();

  const loadAllData = async () => {
    // await itemsStorage.loadItems().catch((error) => {
    //   notification.error({ message: error.message });
    // });
    // await brandsStorage.loadBrands().catch((error) => {
    //   notification.error({ message: error.message });
    // });
    // await partTypes.loadPartTypes().catch((error) => {
    //   notification.error({ message: error.message });
    // });
    // await storeStorage.loadItems().catch((error) => {
    //   notification.error({ message: error.message });
    // });
    //   await dronesStorage.loadDrones().catch((error) => {
    //     notification.error({ message: error.message });
    //   });
    //   await ordersStorage.loadOrders().catch((error) => {
    //     notification.error({ message: error.message });
    //   });
  }

  useEffect(() => {
    loadAllData()
      .then(() => {
        notification.success({ message: "Data loaded" });
      })
      .catch((error) => {
        notification.error({ message: error.message });
      });
  }, []);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const [sidebarMenu, currentSelectedItemKey] = getSidebarMenu(location.pathname);

  return (
    <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="demo-logo-vertical" />
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[currentSelectedItemKey]}
          items={sidebarMenu}
          onClick={({ item }: { item: any}) => {
            navigate(item.props.link);
          }}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            padding: 0,
            margin: 0,
            background: colorBgContainer,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '95%',
        }}
        >
          <Space>
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: '16px',
                width: 64,
                height: 64,
              }}
            />
            <PathHeader />
          </Space>
          <MainToolbar />
        </Header>
        <Content
          style={{
            margin: '8px 16px',
            // padding: 16,
            minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            {/*<Route path="/electronics" element={<NxWelcome title='EL' />} />*/}
            <Route path="/drone-parts" element={<DronePartsPage />} />
            <Route path="/drone-complects" element={<DroneComplect />} />
            <Route path="/suppliers" element={<SuppliersPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/store" element={<StorePage />} />
            <Route path="/drones" element={<DronesPage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/batteries" element={<Batteries />} />
            <Route path="/v2">
              <Route path="" element={<HomePageV2 />} />
              <Route path="suppliers" element={<SuppliersPageV2 />} />
              <Route path="stock" element={<StockPageV2 />} />
              <Route path="products" element={<ProductsPageV2 />} />
              <Route path="drafts" element={<DraftsPageV2 />} />
              <Route path="settings" element={<SettingsPageV2 />} />
              <Route path="orders" element={<OrdersPageV2 />} />
              <Route path="links" element={<LinksPage />} />
            </Route>
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
}

export default observer(Application);
